import { methods } from "../../utils/axios";

export default class CollaboratorsAPI {
  static downloadReports(params) {
    return methods.post('/collaborators/download-reports', params);
  }
  static sendReports(params) {
    return methods.post('/clients/notify-reports-email', params);
  }
  static collaboratorsList(params) {
    return methods.post('/collaborators/paginate', params);
  }
  static collaboratorTests(params) {
    return methods.post('/collaborators/with_tests', params);
  }
  static updateCollaborator(data, id) {
    return methods.put(`/collaborators/${id}`, data);
  }
  static createCollaborator(data) {
    return methods.post('/collaborators', data);
  }
  static resendInvitation(data) {
    return methods.post('/collaborator_tests/send', data);
  }
  static sendInvitation(data) {
    return methods.put('/collaborator_tests', data);
  }
  static buildIaSummary(data) {
    return methods.post('/prompt', data);
  }
  static bulkLoad(data) {
    // return axiosMethods.postDocument('/collaborators/bulk-load', data);
    const headers = { 'Content-Type': 'multipart/form-data' };

    return methods.post('/collaborators/bulk-load', data, { headers });
  }
  static donwloadInform(id, extension) {
    // return axiosMethods.get(`/${id}.${extension}`);
    return methods.get(`/${id}.${extension}`);
  }
  static getExcelTemplate() {
    // return axiosMethods.get('/collaborators/excel')
    return methods.get('/collaborators/excel')
  }
  static deleteCollaborator(id) {
    return methods.del('/collaborators', id)
  }
  static discColorPair(answers) {
    return methods.post('/collaborator_tests/disc_color_pair', { answers });
  }
  static startTestSession(collaboratorTestID, progress) {
    return methods.post('/collaborator_tests/session/start', { collaboratorTestID, progress });
  }
  static saveTestProgress(collaboratorTestID, progress) {
    return methods.post('/collaborator_tests/session/progress', { collaboratorTestID, progress });
  }
}